export enum PrivateDocumentCategory {
  PRIVATE_AGREEMENTS = 'PRIVATE_AGREEMENTS',
  PUBLIC_AGREEMENTS = 'PUBLIC_AGREEMENTS',
  INFORMATION_SHEETS = 'INFORMATION_SHEETS',
  BANK_DOCUMENTS = 'BANK_DOCUMENTS',
  PAYMENT_DOCUMENTS = 'PAYMENT_DOCUMENTS',
  POWERS = 'POWERS',
  CORPORATE_DOCUMENTS = 'CORPORATE_DOCUMENTS',
  FAMILY_DOCUMENTS = 'FAMILY_DOCUMENTS',
  OTHER = 'OTHER',
}
